const experiencesData = [
    {
        company: 'Spoke Phone',
        location: 'Auckland, New Zealand',
        role: 'Software Developer Intern',
        dates: 'May 2024 – Aug. 2024',
        bullets: [
            'Resolved test warnings and errors across React/Apollo components by auditing mock lifecycles, fixing cache configurations, and enforcing Jest reset patterns — improving automated test reliability by 25%.',
            'Migrated 3 deprecated API services and integrated 2 new ones via React and GraphQL updates, maintaining zero regression failures across the affected components post-deployment.'
        ]
    }
];

const Experiences = () => {
    return (
        <section className="experiences-section">
            <h2 className="section-title">Experience</h2>
            {experiencesData.map((exp, i) => (
                <div key={i} className="experience-card">
                    <div className="experience-header">
                        <div>
                            <h3 className="experience-role">{exp.role}</h3>
                            <p className="experience-company">{exp.company} &middot; {exp.location}</p>
                        </div>
                        <span className="experience-dates">{exp.dates}</span>
                    </div>
                    <ul className="experience-bullets">
                        {exp.bullets.map((bullet, j) => (
                            <li key={j}>{bullet}</li>
                        ))}
                    </ul>
                </div>
            ))}
        </section>
    );
};

export default Experiences;
